// src/store/slices/tutorProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TutorProfileState {
    selectedView: string;
}

const initialState: TutorProfileState = {
    selectedView: '/info',
};

const tutorProfileSlice = createSlice({
    name: 'tutorProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = tutorProfileSlice.actions;
export default tutorProfileSlice.reducer;